module.exports = __webpack_public_path__ + "img/t4.8f69956e.png";